export default __webpack_public_path__ + "static/media/step-5-ar.23ce7c7a.png";